function PromiseQueue() {
	this._queue = [];
	this._working = false;
}

PromiseQueue.prototype.push = function (cb, onFail) {
	this._queue.push({ cb: cb, err: onFail });
	if (!this._working) {
		this._nextEntry();
	}
};

PromiseQueue.prototype._nextEntry = function () {
	var next;
	this._working = true;

	if (this._queue.length > 0) {
		next = this._queue.shift();
		next.cb().then(this._nextEntry.bind(this), next.err);
	} else {
		this._working = false;
	}
};

PromiseQueue.prototype.reset = function () {
	this._working = false;
	this._queue = [];
};

module.exports = PromiseQueue;
